import http from './httpService';
import config from './../config.json';



export const adminLogin = (password) => {
    return http.post(config.server_address + '/login', { password});
}
